import { getTransactions } from "@/services/transactions.service";
import { useQuery } from "@tanstack/react-query";

export const useTransactions = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "transactions",
    params.page,
    params.size,
    params.status,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getTransactions(params),
    enabled,
    ...options,
  });
};
